// Resolve the unit price for a product + selected variant.
// Variant options: [{ name, price|null }] — price overrides the base price when set.
export function variantUnitPrice(product, variantName) {
  if (!product) return 0;
  const base = Number(product.price) || 0;
  if (!variantName) return base;
  const vo = (product.variantOptions || []).find((v) => v.name === variantName);
  if (vo && vo.price != null && !Number.isNaN(Number(vo.price))) return Number(vo.price);
  return base;
}
